<template>
    <section id="bailes">
        <div class="container">
            <h2 >Pacote de bailes</h2>

                <div class="preco">
                    <p>Adiquira já o pacote com todos os <strong>4 bailes</strong> por apenas:</p>
                    <p class="valor">R$ 130,00</p>
                </div>

                <p class="obs">Obs: Apenas para quem <strong>não</strong> adquiriu o pacote SM!</p>
                <br>
                <p>Se você já é um Maníaco 2020, pode estar adquirindo as entradas de quinta e domigo na portaria do evento!</p>
                <!-- <a href="/bailes" class="btn btn-success">
                    Comprar pacote de bailes
                </a> -->
            <div class="pagamento">
                <div>
                    <p class="titulo">Conta para depósito</p>
                    <p>Banco: 290 - PagSeguro Internet S.A.</p>
                    <p>Agência: 0001</p>
                    <p>Número da conta: 07228469-2</p>
                    <p>CPF: 058.046.577-20</p>
                    <p>Tipo: Conta de pagamento</p>
                </div>
                <div>
                    <p class="titulo">Enviar comprovante para:</p>
                    <p>(21) 9 8229-0654</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data () {
        return {}
    }
}
</script>

<style lang="sass">
    @import "../../../assets/sass/_mixin"
    #bailes
        padding: 120px 0
        text-align: center
        background-color: #f5f3ff
        > div
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center
            h2
                margin-bottom: 30px
            p
                max-width: 480px
            p.titulo
                font-weight: 600
            a
                width: 200px
                margin-left: auto
                margin-right: auto
                margin-top: 20px
                height: 55px
                width: 300px
                border-radius: 150px
                @include device(mobile)
                    &
                        width: 90%
                        margin: 0 auto
            .preco
                p:first-of-type
                    margin-bottom: 0
                .valor
                    color: green
                    font-size: 30px
                    font-weight: 600
            .obs
                border-bottom: 1px solid black
            .pagamento
                p
                    margin-bottom: 0
                p.titulo
                    margin-bottom: 10px
                    margin-top: 15px
</style>
